import { apiRequest } from "store/Misc/apiRequest"

export const getImpressions = async (budget) => {
    const result = await apiRequest({
        method: 'post',
        url: 'promos/campaigns/get-impressions-by-budget',
        payload: { budget }
    })
    // alert(result?.data)
    // setTargetCount(targetCount => ({ ...targetCount, impressions: result.data }))
    return result?.data

}